import { Component, Host, h, Prop, Watch, State } from '@stencil/core'
import { INDICATORS_COLORS_TYPES } from '../../utils'

@Component({
  tag: 'snap-indicator',
  styleUrl: 'snap-indicator.scss',
  shadow: true,
})
export class SnapIndicator {
  @Prop() size: 'tiny' | 'sm' | 'lg' = 'tiny'
  @Prop() color: INDICATORS_COLORS_TYPES
  @Prop() text: string | number

  @State() moreThanOneCharacters = false

  @Watch('text')
  onTextChange() {
    if (this.text) {
      const string = this.text.toString()
      let length: number
      if (string.length > 0) {
        length = string.split('').length
      }
      this.moreThanOneCharacters = !!length && length > 1
    } else {
      this.moreThanOneCharacters = false
    }
  }

  connectedCallback() {
    this.onTextChange()
  }

  render() {
    return (
      <Host
        class={{
          [`snap-indicator-${this.color}`]: true,
          [`snap-indicator-${this.size}`]: true,
          'more-than-one': this.moreThanOneCharacters,
        }}>
        <div class="snap-indicator">
          {this.text}
        </div>
      </Host>
    )
  }
}
